export const FF_PRELOAD_TIMEOUT = 'confluence.frontend.fabric.editor.preload.timeout';
